import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import { styled } from '@classify/react-core-components/styles';
import ContentWrapper from '@classify/react-core-components/ContentWrapper';
import Section from '../Section';
import PathBanner from './PathBanner';
interface Props {
  children: ReactNode;
}
const Root = styled(Section)(({
  theme: {
    palette,
    spacing
  }
}) => ({
  background: palette.notification.neutral.background,
  padding: spacing(6, 0)
}));
const PathPromotionWrapper = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <Root><ContentWrapper><PathBanner>{children}</PathBanner></ContentWrapper></Root>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default PathPromotionWrapper;